import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface AddToWishlist extends GtagEvent {
    currency:ISO_4217;
    value: number;
    items:Item[]
}
export const add_to_wishlist = ($_:AddToWishlist) => event('add_to_wishlist',$_);